import { useMemo } from "react";
import Modal from "react-bootstrap/Modal";
import { BsCheckCircleFill } from "../../../assets/icons/vander";
import { formatEventDate } from "../../../helpers";
import { useScheduleEventStore, usePatientSurgeryStore } from "../../hooks";
import { MainButton } from "../../ui";

export const AssessmentScheduledModal = ({
  isOpen,
  setIsOpen,
  handleViewAssessmentScheduled,
}) => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    scheduleEvents,
  } = useScheduleEventStore();

  const {
    // Props
    patientSurgery,
  } = usePatientSurgeryStore();

  const { state } = patientSurgery.data;

  const assessmentScheduleEvent = useMemo(() => {
    const typeByState = {
      SCHEDULED_ASSESSMENT: "INITIAL_ASSESSMENT",
      RESCHEDULED_ASSESSMENT: "INITIAL_ASSESSMENT",
      SCHEDULED_ASSESSMENT_FINAL: "FINAL_ASSESSMENT",
    };

    const expectedType = typeByState[state];
    if (!expectedType) return null;

    const filtered = scheduleEvents
      .filter(
        (scheduleEvent) =>
          scheduleEvent.type === expectedType && scheduleEvent.attended == null
      )
      .sort((a, b) => a.start - b.start);

    return filtered[0] ?? null;
  }, [scheduleEvents, state]);

  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  return (
    <Modal
      show={isOpen}
      onHide={() => {
        setIsOpen(false);
      }}
      centered
      size="lg"
      keyboard={false}
      backdrop="static"
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        {assessmentScheduleEvent && (
          <div className="vstack text-center gap-3">
            <BsCheckCircleFill
              className="icon text-success mx-auto"
              style={{ width: "48px", height: "48px" }}
            />
            <h1 className="mb-0">¡Valoración agendada con éxito!</h1>
            <p className="mb-0">
              Tu valoración ha sido agendada para el{" "}
              <b>{formatEventDate(assessmentScheduleEvent.start)}</b> Si
              necesitas reagendar, podrás hacerlo fácilmente utilizando este
              mismo enlace. <br />
              <br />
              Ya puedes salir de esta página.
            </p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <MainButton
          type="button"
          className={`mx-auto`}
          onClick={() => {
            handleViewAssessmentScheduled();
          }}
        >
          Revisar valoración agendada
        </MainButton>
      </Modal.Footer>
    </Modal>
  );
};
